module.exports = __webpack_public_path__ + "static/media/9010_5011.2d151667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/9010_5011.jpg
// module id = 68
// module chunks = 0